import type { Placement, Rect } from "./types";
import type { AssetDimensions } from "./renderSpec";

// 画像スロットの配置を「枠を常に覆う」範囲に制限する。
// 倍率 1 未満や過大なオフセットを許すと枠内に余白（背景）が露出するため
export function clampPlacement(
  image: AssetDimensions,
  frame: Rect,
  placement: Placement,
  maxScale = 8,
): Placement {
  const scale = Math.min(Math.max(placement.scale, 1), maxScale);
  const base = Math.max(frame.width / image.width, frame.height / image.height);
  const width = image.width * base * scale;
  const height = image.height * base * scale;
  const maxOffsetX = (width - frame.width) / 2;
  const maxOffsetY = (height - frame.height) / 2;
  return {
    scale,
    offsetX: Math.min(Math.max(placement.offsetX, -maxOffsetX), maxOffsetX),
    offsetY: Math.min(Math.max(placement.offsetY, -maxOffsetY), maxOffsetY),
  };
}
